var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.systemTag)?_c('div',{staticClass:"top"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.systemTag))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }